import { useCallback } from 'react'
import { Input } from '@components/atoms'
import { useContextSelector } from 'use-context-selector'
import { SideFilterSelectContext } from '../SideFilterSelect/SideFilterSelectContext'
import { PropositionTypeGroups } from '@enums/PropositionTypeEnum'
import { FilterList, FilterListItem } from './PropositionTypeFilter.styles'

function PropositionTypeFilter(): JSX.Element {
  const selecteds = useContextSelector(
    SideFilterSelectContext,
    (s) => s.selecteds
  )
  const setSelecteds = useContextSelector(
    SideFilterSelectContext,
    (s) => s.setSelecteds
  )

  // Check if all acronyms of a group are selected
  const isGroupSelected = useCallback(
    (acronyms: string[]) => {
      return acronyms.every((acronym: string) => selecteds.includes(acronym))
    },
    [selecteds]
  )

  // Handle group selection/deselection
  const handleToggleGroup = useCallback(
    (acronyms: string[]) => {
      const isSelected = isGroupSelected(acronyms)

      if (isSelected) {
        // Remove all acronyms of this group
        setSelecteds(
          selecteds.filter((selected: string) => !acronyms.includes(selected))
        )
      } else {
        // Add all acronyms of this group
        const newSelecteds = [...selecteds]
        acronyms.forEach((acronym: string) => {
          if (!newSelecteds.includes(acronym)) {
            newSelecteds.push(acronym)
          }
        })
        setSelecteds(newSelecteds)
      }
    },
    [selecteds, isGroupSelected, setSelecteds]
  )

  return (
    <FilterList>
      {Object.entries(PropositionTypeGroups).map(([key, group]) => (
        <FilterListItem key={key} disablePadding>
          <Input
            type="checkbox"
            label={group.label}
            value={key}
            checked={isGroupSelected(group.acronyms)}
            onChange={() => handleToggleGroup(group.acronyms)}
          />
        </FilterListItem>
      ))}
    </FilterList>
  )
}

export default PropositionTypeFilter
